import { NumericFormat as NumberFormat } from "react-number-format";
import { Form } from "react-bootstrap";

import { format as formatDate } from "../../utils/date";
import { currency as formatCurrency } from "../../utils/number";
import { only as numbersOnly } from "../../utils/number";
import { phone } from "../../utils/string";

export function onCurrencyFormat(e) {
    return formatCurrency(Number(e));
}

export function onCurrencyControlRender(e, row, name, onChange, {prefix="$", thousandSeparator=true, allowNegative=false }) {
    return (<>
        <NumberFormat
            displayType="input"
            type="text"
            name={name}
            className="text-end form-control"
            prefix={prefix}
            thousandSeparator={thousandSeparator}
            allowNegative={allowNegative}
            value={e}
            onValueChange={(e) =>
                onChange({
                    name,
                    value: e.floatValue,
                    row: row
                })
            }
            removeFormatting
        /></>);
}

export function onDateFormat(e) {
    return formatDate(e, false);
}

export function onTextControlRender(e, row, name, onChange, { defaultValue = "" }) {
      
    return (<>
        <Form.Control
            type="text"
            name={name}
            value={e || defaultValue}
            onChange={(e) => onChange({
                name,
                value: e.target.value,
                row
            })}

        /></>);
}

export function onLinkFormat(e, row, {baseUrl="", id=undefined, text=undefined}) {
    text = (text ?? e) || "";
    baseUrl = baseUrl + (id || "");
    return `<a href="${baseUrl}">${text}</a>`;
}

export function onPhoneLinkFormat(e) {
    if (!e) return "";
    let __phone = numbersOnly(e);
    if (__phone == 1) return "";
    return `<a href="tel:+${__phone}">${phone(__phone)}</a>`
}

export function onColumnClick(e, context, onUpdateFunction) {
    const __array = context.headers;
    const __index = __array.findIndex((item) => {
        return item.header === e.header && item.source === e.source;
    });

    context.setState({
        index: __index,
        direction: context.state.index === __index && context.state.direction === "DESC" ? "ASC" : "DESC",
        order: __array[__index].source,
        page: 0
    }, onUpdateFunction);
}

export function initialState({
    page = 0,
    size = 5,
    search = "",
    order = "createdOn",
    index = 0,
    direction = "DESC",
    data = [],
    items = [],
    pages = 0,
}) {
    return {
        page,
        size,
        search,
        order,
        index,
        direction,
        data,
        items,
        pages,
    }
}